(function(){
  if (window._headerCartLiveInit) return;
  window._headerCartLiveInit = true;

  // Selectors
  const headerCartIconSelector = '[data-cart-icon], .site-header__icon.site-header__cart, a[href="/cart"]';
  const cartCountId = 'CartCount';
  const cartCountSelector = '#' + cartCountId;
  const dataCartCountSelector = '[data-cart-count]';
  const dataCartSubtotalSelector = '[data-cart-subtotal]';

  // Debounce timer to avoid many /cart.js calls
  let refreshTimer = null;
  const REFRESH_DELAY = 350; // ms

  // Update header cart markup (create if missing)
  function renderHeaderCartCount(count) {
    const icon = document.querySelector(headerCartIconSelector);
    if (!icon) return;

    // if count is 0, remove the badge/node
    if (!count || count <= 0) {
      const existing = document.querySelector(cartCountSelector);
      if (existing) existing.remove();
      return;
    }

    // If element exists, just update number
    let el = document.querySelector(cartCountSelector);
    if (!el) {
      // create element similar to your template:
      el = document.createElement('div');
      el.id = cartCountId;
      el.className = 'site-header__cart-count';
      el.innerHTML = `<span>${count}</span><span class="icon__fallback-text medium-up--hide"></span>`;
      // append after icon's inner content
      icon.appendChild(el);
      // keep simple — you may want to move this into a specific place in DOM if needed
    } else {
      const span = el.querySelector('span');
      if (span) span.textContent = String(count);
      const fallback = el.querySelector('.icon__fallback-text');
      if (fallback) fallback.textContent = `${count} items`;
    }
  }

  // Update all data-cart-count and subtotal elements from cart JSON
  async function refreshCountsFromCartJs() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!r.ok) return;
      const cart = await r.json();

      // update header/cart count
      renderHeaderCartCount(cart.item_count);

      // update data-cart-count nodes
      document.querySelectorAll(dataCartCountSelector).forEach(el => {
        el.textContent = cart.item_count;
      });

      // update cart subtotal nodes (cart.total_price is cents)
      document.querySelectorAll(dataCartSubtotalSelector).forEach(el => {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          try { el.textContent = Shopify.formatMoney(cart.total_price); return; } catch(e){}
        }
        el.textContent = '$' + (cart.total_price / 100).toFixed(2);
      });

      // emit a custom event for other parts of the theme
      document.dispatchEvent(new CustomEvent('headerCart:refreshed', { detail: cart }));
    } catch (err) {
      // silent fail — don't break page
      console.warn('refreshCountsFromCartJs error', err);
    }
  }

  // Debounced public call
  function scheduleRefreshCounts(delay = REFRESH_DELAY) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      refreshTimer = null;
      refreshCountsFromCartJs();
    }, delay);
  }

  // Expose for manual calls
  window.refreshHeaderCart = refreshCountsFromCartJs;
  window.scheduleRefreshHeaderCart = scheduleRefreshCounts;

  // Listen for custom events other scripts may fire
  document.addEventListener('cart:updated', () => scheduleRefreshCounts(50));
  document.addEventListener('product:added-to-cart', () => scheduleRefreshCounts(50));
  document.addEventListener('headerCart:refresh', () => scheduleRefreshCounts(50));

  // If your drawer code calls refreshCartDrawer() and updates DOM, we still want accurate counts.
  // Watch for click actions inside cart drawer that change quantity (delegation).
  document.addEventListener('click', function(e){
    // qty buttons and remove buttons inside drawer or on cart page
    const decrease = e.target.closest('[data-qty-decrease]');
    const increase = e.target.closest('[data-qty-increase]');
    const remove = e.target.closest('[data-cart-remove]');
    if (decrease || increase || remove) {
      // give the theme's update handler ~300ms to finish network update, then refresh
      scheduleRefreshCounts(350);
    }

    // If user clicks a product-card add button (quick-add), refresh after short delay
    const quickAdd = e.target.closest('[data-product-card-add]');
    if (quickAdd) scheduleRefreshCounts(300);
  }, { passive: true });

  // Listen for manual editing of quantity inputs
  document.addEventListener('change', function(e){
    const qtyInput = e.target.closest('[data-qty-input], input[name="quantity"], input[name="updates[]"]');
    if (!qtyInput) return;
    scheduleRefreshCounts(350);
  });

  // Also observe the cart count element for changes (fallback)
  const cartIcon = document.querySelector(headerCartIconSelector);
  if (cartIcon) {
    try {
      const mo = new MutationObserver(() => scheduleRefreshCounts(200));
      mo.observe(cartIcon, { childList: true, subtree: true, characterData: true });
      // store it so it can be disconnected if needed
      window._headerCartCountObserver = mo;
    } catch (e) { /* ignore in older browsers */ }
  }

  // Initial sync when script loads
  scheduleRefreshCounts(100);

})();

